import axios from 'axios';
import { openModal, closeModal } from './modal';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

const container = document.querySelector('.test__container');
const errorTxt = container?.dataset.error;

// --- AJAX ---
async function sendRate(postId, rate) {
  const ajaxurl = '/wp-admin/admin-ajax.php';
  const formData = new FormData();
  formData.append('action', 'rate_test');
  formData.append('post_id', postId);
  formData.append('rate', rate);

  try {
    const response = await axios.post(ajaxurl, formData);
    return response.data;
  } catch (error) {
    showToast(errorTxt, 'error');
    return { success: false };
  }
}

// --- localStorage ---
function saveLocalRate(postId, rate) {
  let rates = JSON.parse(localStorage.getItem('rates') || '{}');
  rates[postId] = rate;
  localStorage.setItem('rates', JSON.stringify(rates));
}

function getLocalRate(postId) {
  let rates = JSON.parse(localStorage.getItem('rates') || '{}');
  return rates[postId] || null;
}

// --- закривання ---
function attachCloseHandler(rateWindow) {
  const closeBtn = rateWindow.querySelector('.closeModalMob');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', e => {
    e.preventDefault();
    const modal = rateWindow.closest('.modal');
    if (modal) {
      closeModal(modal);
    } else {
      rateWindow.classList.remove('opened');
      rateWindow.style.opacity = '0';
      rateWindow.style.visibility = 'hidden';
    }
  });
}

// --- HTML для вже виставленої оцінки ---
function getRatedMarkup(rateWindow, rate) {
  const t1 = rateWindow.dataset.t1 || 'Ваша оцінка:';
  const t2 = rateWindow.dataset.t2 || 'з 5';
  const t3 = rateWindow.dataset.t3 || 'Закрити';

  const isModal = !!rateWindow.closest('.modal');

  const closeBtn = isModal
    ? `<div class="close-modal btn-def white closeModalMob">${t3}</div>`
    : `<button class="close btn-def white closeModalMob" type="button">${t3}</button>`;

  return `
    <div class="ratewin__title">${t1}</div>
    <div class="ratewin__starscont">
      <div class="ratevin__stars">
        ${Array.from({ length: 5 }, (_, i) => {
          const active = i < rate ? 'active' : '';
          return `<label class="star ${active}">
                    <input type="radio" name="rate" value="${i + 1}" disabled />
                  </label>`;
        }).join('')}
      </div>
      <div class="stars__text"><span>${rate}</span> ${t2}</div>
    </div>
    <div class="rate__buttons">
      ${closeBtn}
    </div>
  `;
}

function renderRatedWindow(rateWindow, rate) {
  rateWindow.innerHTML = getRatedMarkup(rateWindow, rate);
  attachCloseHandler(rateWindow);
}

// --- Спільна логіка відправки ---
async function handleRateSubmit(rateWindow, postId, value) {
  if (!postId || !value) return;

  rateWindow.classList.add('loading');
  const data = await sendRate(postId, value);

  if (data.success) {
    saveLocalRate(postId, value);
    document.querySelectorAll('.rate__window').forEach(w => {
      renderRatedWindow(w, value);
    });
    const rateEl = document.querySelector('.item__rate .rate');
    if (rateEl) rateEl.textContent = data.data.average;
  } else {
    showToast(errorTxt, 'error');
  }
  rateWindow.classList.remove('loading');
}

// --- ініціалізація ---
function initRateWindow(rateWindow, postId) {
  let currentValue = 0;

  const savedRate = getLocalRate(postId);
  if (savedRate) {
    renderRatedWindow(rateWindow, savedRate);
    return;
  }

  const stars = rateWindow.querySelectorAll('.star');
  const starsText = rateWindow.querySelector('.stars__text span');

  function updateStars(val) {
    stars.forEach((star, i) => {
      star.classList.toggle('active', i < val);
    });
  }

  stars.forEach((star, idx) => {
    star.addEventListener('mouseenter', () => updateStars(idx + 1));
    star.addEventListener('mouseleave', () => updateStars(currentValue));

    star.addEventListener('click', async () => {
      currentValue = idx + 1;
      if (starsText) starsText.textContent = currentValue;

      const radio = star.querySelector('input');
      if (radio) radio.checked = true;

      // Перевірка: чи ми в режимі результату?
      const isResultMode = container && container.classList.contains('resilt');

      if (isResultMode) {
        // Миттєва відправка без кнопки
        await handleRateSubmit(rateWindow, postId, currentValue);
      } else {
        // Звичайний режим: активуємо кнопку
        rateWindow.querySelector('.submit__rate')?.removeAttribute('disabled');
      }
    });
  });

  // --- Ручний submit (якщо не режим результату) ---
  rateWindow.addEventListener('click', async e => {
    const btn = e.target.closest('.submit__rate');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();
    await handleRateSubmit(rateWindow, postId, currentValue);
  });

  attachCloseHandler(rateWindow);
  updateStars(currentValue);
}

// --- запуск ---
document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('.openrate');
  if (!openBtn) return;

  const postId = openBtn.dataset.id;

  openBtn.addEventListener('click', e => {
    e.preventDefault();
    if (window.innerWidth > 520) {
      const desktopWin = document.querySelector('.item__rate .rate__window');
      if (desktopWin) {
        desktopWin.classList.add('opened');
        desktopWin.style.opacity = '1';
        desktopWin.style.visibility = 'visible';
      }
    } else {
      openModal('id-rating');
    }
  });

  document.querySelectorAll('.rate__window').forEach(rateWindow => {
    initRateWindow(rateWindow, postId);
  });
});

function showToast(message, type = 'error') {
  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: 'top',
    position: 'right',
    stopOnFocus: true,
    style: {
      background: type === 'error' ? '#e74c3c' : '#27ae60',
      borderRadius: '.5rem',
      padding: '.7rem 1rem',
      fontSize: '.875rem',
    },
  }).showToast();
}
